// const { baseURL } = require('@/config')
import request from '@/utils/request'
// import qs from 'qs'

/**
 *  登录
 *  查询业务token和用户信息token
 * @param {*} data 
 * @returns 
 */
export function queryToken(id) {
  return request({
    url: '/token/queryUserAndServiceToken?userId='+id,
    head: 'application/json;charset=UTF-8',
    method: 'get',
  })
}
